import { INPUT_TYPE } from "globalConstants";
import { ICommonFixture } from "types";

const fixture: ICommonFixture[] = [
    {
        name: "aadhar",
        label: "Aadhar",
        inputType: INPUT_TYPE.TEXT,
        defaultValue: "",
        subtitle: "Validate Aadhar",
    },
];

export default fixture;
